module.exports = __webpack_public_path__ + "img/inside-border.57b65c99.png";